import React from 'react';
import "./SASSYStatisticsBlock.css";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

// eslint-disable-next-line
const SegmentDescriptions = new Map([
  ["Alarmed", ["Certain that global warming is happening, human-caused, and harmful", "Strongly support climate policies – most likely to engage in political activism", "But, often do not know what they or society can do"]],
  ["Concerned", ["Moderately certain that global warming is happening, human-caused, and harmful", "See the problem primarily as a distant threat, however – harmful mainly to other nations and future generations", "Support action on climate change, but unlikely to have engaged in political activisim"]],
  ["Cautious", [`"Fence-sitters" – Uncertain that global warming is happening and human-caused`, "Global warming seems like a distant threat", "No strong opinions on what, if anything, should be done"]],
  ["Disengaged", ["Rarely hear about global warming and know very little about the issue", "Need basic information about climate change"]],
  ["Doubtful", ["Uncertain whether global warming is happening", "If it is happening, think it is likely not human-caused", "Tend to be politically conservative and hold traditional religious views"]],
  ["Dismissive", ["Believe that global warming is not occurring, or that if it is occuring is not human-caused", "Strongly oppose policies and action to reduce the threat", "May have contacted an elected representative to argue against action on global warming"]]
]);

export default function SASSYStatisticsBlock(props) {
  return <div className="ui statistics">
    {props.stats.map(stat => (
      <Card key={stat.name} className="ui statistic-block" elevation={0}>
        <CardContent className="statistic">
          <Typography variant="headline" component="h2">
            {stat.value}
          </Typography>
          <Typography color="textSecondary" className={'stats-label ' + stat.name.toLowerCase()}>
            {stat.name}
          </Typography>
        </CardContent>
      </Card>
    ))}
  </div>;
}